import { useTranslation } from 'react-i18next';
import { Controller, useFormContext } from 'react-hook-form';
import { FormGroup, Input, Label } from 'reactstrap';
import FormGroupNote from '../FormGroupNote';

export default function NotifyClientOnStatusChangeCheckbox({ isDisabled }) {
  const { t } = useTranslation();

  const {
    control,
    formState: { errors }
  } = useFormContext();

  const inputName = 'notifyClientOnStatusChange';

  return (
    <FormGroup className="d-flex align-items-center">
      <Label htmlFor={inputName} className="m-0 mr-2">
        {t('Notify client on status change')}
      </Label>
      <Controller
        control={control}
        name={inputName}
        render={({ field }) => (
          <Input
            id={inputName}
            type="checkbox"
            {...field}
            checked={!!field.value}
            disabled={isDisabled}
            className="m-0 position-static"
          />
        )}
      />
        {errors.notifyClientOnStatusChange && (
          <FormGroupNote type="warning">
            {errors.notifyClientOnStatusChange.message}
          </FormGroupNote>
        )}
    </FormGroup>
  );
}